import Raven from 'raven-js'

Raven.config('https://25dc37e4288b4d63a065981d7444bbe6@sentry.io/300639', {
  debug: process.env.NODE_ENV === 'development',
  shouldSendCallback: () => process.env.NODE_ENV !== 'development'
}).install()



// WEBPACK FOOTER //
// ./src/config/raven.js